import { createFileRoute, redirect } from '@tanstack/react-router';
import { getSession } from '../../../lib/session';
import { usePageTitle } from '../../../lib/hooks';
import { MaintenanceManager } from '../../../features/admin/maintenance/MaintenanceManager';

function AdminMaintenanceRoute() {
  usePageTitle('Maintenance');
  return <MaintenanceManager />;
}

export const Route = createFileRoute('/_auth/admin/maintenance')({
  beforeLoad: ({ location }) => {
    const session = getSession();
    const isAllowed =
      session?.user.type === 'group_admin' ||
      session?.user.type === 'company_admin' ||
      session?.permissions.includes('admin.maintenance.write');

    if (!isAllowed) {
      throw redirect({
        to: '/',
        search: { callbackUrl: location.href },
      });
    }
  },
  component: AdminMaintenanceRoute,
});
